import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
// import { makeStyles } from '@material-ui/core/styles'
import HomeIcon from '@material-ui/icons/Home'
import RBarButton from './RBarButton'
import { barVisibleSelector } from '../../../modules/reducerMaster'

import { modeSelector, MODE, resetView } from '../../../modules/reducerRotator'

// const useStyles = makeStyles((theme) => ({
//   root: {}
// }))

const RHomeButton = (props) => {
  // const classes = useStyles()
  const barVisible = useSelector(barVisibleSelector)
  const mode = useSelector(modeSelector)
  const dispatch = useDispatch()

  const handleClick = useCallback(() => {
    dispatch(resetView())
  }, [dispatch])

  return (
    <RBarButton
      {...props}
      tooltip="Default view"
      tooltipEnabled={barVisible}
      onClick={handleClick}
      disabled={
        mode === MODE.ROT_AUTOMATIC ||
        mode === MODE.ROT_MOUSE ||
        mode === MODE.PANNING
      }
    >
      <HomeIcon fontSize="inherit" />
    </RBarButton>
  )
}
export default RHomeButton
